import Vue from 'vue';
import App from './App.vue';

// Import Stripe
import '@stripe/stripe-js';

// Imports Global Styles
import './assets/_fonts.scss';
import 'cadpro-design-tools/styles/_all.scss';
import './assets/styles.scss';
import './assets/stripe.scss';
import './assets/_navbar.scss';
import 'bulma';
import 'buefy/src/scss/buefy-build.scss';

// Imports Global Plugins
import 'cadpro-design-tools/vue/plugins/buefy';
import 'cadpro-design-tools/vue/plugins/clipboard';
import 'cadpro-design-tools/vue/plugins/cadproicons';
// import "cadpro-design-tools/vue/plugins/cookies";
import 'cadpro-design-tools/vue/plugins/currency';
import 'cadpro-design-tools/vue/plugins/date';
import 'cadpro-design-tools/vue/plugins/font';
import 'cadpro-design-tools/vue/plugins/fontawesome';

// Import router
import router from './router';

import Navbar from './components/Navbar.vue';

Vue.component('Navbar', Navbar);

new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
